import React from 'react';
import * as Styled from './StyledButton';

export const Button = ({ children, variant = 'default', size = 'medium', ...rest }) => {
    return (
        <Styled.Button size={size} variant={variant} type="button" {...rest}>
            {children}
        </Styled.Button>
    );
};

export default Button;
